<template>
    <div>
        <b-form>

            <b-col cols="12" class="d-flex justify-content-end">
                <b-button variant="primary" @click="adicionarVigencia">
                    +
                </b-button>
            </b-col>
            <b-table responsive class="mt-2" small :items="contratoForm.vigencias" :fields="fields" hover>
                <template v-slot:cell(dataInicial)="data">
                    <lg-form-date class="mt-2 mb-2" invalidFeedback=" " description=" " v-model="data.item.dataInicial"
                        label=" " />
                </template>

                <template v-slot:cell(observacao)="data">
                    <lg-form-input class="mt-2 mb-2" v-model="data.item.observacao" label=" " description=" " />
                </template>
                <template v-slot:cell(situacao)="data">
                    <lg-form-const-select class="mt-2 mb-2" label="" v-model="data.item.situacao"
                        :options="opcoesSituacao" />
                </template>

                <template v-slot:cell(dataFinal)="data">
                    <lg-form-date class="mt-2 mb-2" invalidFeedback=" " description=" " v-model="data.item.dataFinal"
                        label=" " />
                </template>

                <template v-slot:cell(tipoVigencia)="data">
                    <LgFinderPageTipoVigencia class="mt-2 mb-2" label=" " v-model="data.item.tipoVigencia"
                        @input="function(item){setVigencia(data.item, item)}" :prefix="prefix" />
                </template>
                <template v-slot:cell(acoes)="data">
                    <b-button v-if="!isEditMode" size="sm" pill variant="danger" @click="removerVigencia(data.index)">
                        <b-icon icon="trash" />
                    </b-button>
                </template>
            </b-table>
        </b-form>
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import LgFinderPageTipoVigencia from "@/components/Finders/LgFinderPageTipoVigencia.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"

export default {
    name: "VigenciasForm",
    components: {
        LgFormInput,
        LgFormConstSelect,
        LgFinderPageTipoVigencia,
        LgFormDate
    },
    mixins: [validationMixin],
    props: {
        prefix: {
            type: String,
            default: ""
        },
        contratoFormProp: {
            type: Object,
            required: true,
        },
        isEditMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            contratoForm: this.contratoFormProp,
            isEditingVigencia: false,
            indexEdicao: null,
            fields: [
                { key: "dataInicial", label: "Data Inicial" },
                { key: "dataFinal", label: "Data Final" },
                { key: "tipoVigencia", label: "Tipo Vigência" },
                { key: "observacao", label: "Observação", },
                { key: "situacao", label: "Situação", class: "text-center" },
                { key: "acoes", label: "Ações", class: "text-center" },
            ],
            opcoesSituacao: [
                { value: 1, text: "Ativa" },
                { value: 0, text: "Inativa" },
            ],
        };
    },
    methods: {
        setVigencia(item, vigencia) {
            item.tipoVigencia = vigencia;
        },
        adicionarVigencia() {
            this.contratoForm.vigencias.push({ situacao: 1,  dataInicial: "", dataFinal: "", observacao: "", tipoVigencia: {} });
        },
        removerVigencia(index) {
            this.contratoForm.vigencias.splice(index, 1);
        },

    },
};
</script>

<style scoped>
.mt-2 {
    margin-top: 0.5rem;
}

.ml-2 {
    margin-left: 0.5rem;
}

.mt-3 {
    margin-top: 1rem;
}
</style>
